<main class="container-fluid main-container my-5" *ngIf="event$ | async as event; else noEvent">
  <h1 class="subtitle mt-3">Aangemelde gebruikers voor {{ event.name }}</h1>
  <a class="text-decoration-none back-link" [routerLink]="['/mijn-organisatie/activiteiten']"><i class="bi bi-arrow-left me-2"></i>Vorige pagina</a>
  <hr>
  <ul class="signee-list">
    <li class="signee-container" *ngFor="let signee of signees">
      <div class="img-container" [ngStyle]="{'background-image': 'url(assets/img/profile-picture.png)'}"></div>
      <div class="signee-content">
        <div class="signee-info">
          <p class="signee-name">
            {{ signee.name }}
          </p>
          <p class="signee-email">Emailadres: {{ signee.email }}</p>
          <button class="contact-button">Contact opnemen</button>
        </div>
      </div>
    </li>
  </ul>
</main>
<ng-template #noEvent>
  <div class="error-container my-5">
    <img class="error-container-img mb-5" src="assets/img/logo-zonder-tekst.jpg">
    <div class="error-container-text mb-5">
      <h1 class="error-header mb-3"><i>Oeps! Er is iets fout gegaan!</i></h1>
      <p>
        We hebben ons best gedaan, maar het is ons niet gelukt om de activiteit te vinden.
      </p>
      <p>
        Klik hieronder om terug te gaan naar het activiteitenoverzicht van jouw organisatie!
      </p>
      <button type="button" class="btn btn-back mt-2" tabindex="0" [routerLink]="['/mijn-organisatie/activiteiten']">Terug naar het overzicht</button>
    </div>
  </div>
</ng-template>
